var mr_params = (new URL(document.location)).searchParams;
var mr_name = mr_params.get("mrRID");
if (mr_name != null || window.location.href.indexOf("/cart")>-1) {
  function mr_setCookie(cookieName, cookieValue, nHours) {
    var today = new Date();
    var expire = new Date();
    if (nHours == null || nHours == 0) nHours = 1;
      expire.setTime(today.getTime() + 3600000 * nHours);
      document.cookie = cookieName + "=" + escape(cookieValue)
        + ";expires=" + expire.toGMTString() + ';path=/';
}
if (mr_name != null) {
  mr_setCookie("mrRID",mr_name,12);
}
  myregistryPlatformWidget=""; var as = document.createElement('script'); as.id = 'MyRegistryShippingInfo'; as.type ='text/javascript'; as.async = true; as.src ='https://www.myregistry.com/ScriptPlatform/Shopify/ShippingAutopopulate.js?siteKey=4ioV_5hagZtvSYbsZ3YgxA2&version=' + (new Date().getTime()); var s=document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(as, s);
}else{
  myregistryPlatformWidget=""; var as = document.createElement('script'); as.type = 'text/javascript'; as.async = true; as.src = 'https://www.myregistry.com/ScriptPlatform/Shopify/AddToMrButton.js?siteKey=4ioV_5hagZtvSYbsZ3YgxA2&version=' + (new Date().getTime()); var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(as, s);
}
